import BasketItemResourceModel from '../../generated/types/model/resource/BasketItemResourceModel';

export default class BasketItemResourceViewModel extends BasketItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
